import type { ElementTweenFunction } from '../types';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';

export const enterFromBottom: ElementTweenFunction = ({ target,
    options,
    scrollTrigger,
    direction
}
) => {
    if (direction === "back") return { tween: undefined, position: "0" }

    const duration = options?.duration ? options.duration : 1
    const ease = options?.ease ? options.ease : 'expo.out'



    const tween = gsap.fromTo(
        target,
        { y: '450%' }, // Start above the viewport, small
        { y: '0%', duration: duration, ease, },
    )


    if (scrollTrigger?.trigger) {
        ScrollTrigger.create({
            animation: tween,
            ...scrollTrigger,
        });
    }

    return { tween, position: "<" };
};
